import * as React from 'react';
export const IcCarpool = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 8a1 1 0 100 2 1 1 0 000-2zm11.78 4.16L19.4 7.05a3 3 0 00-2.84-2H7.41a3 3 0 00-2.87 2.07l-1.33 5.05A2 2 0 002 14v2a2 2 0 001 1.72V19a1 1 0 002 0v-1h14v1a1 1 0 002 0v-1.28A2 2 0 0022 16v-2a2 2 0 00-1.22-1.84zM6.71 15.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 14.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 11a2 2 0 00-1.72 1h-2.56a2 2 0 00-3.44 0h-2l1.18-4.31a1 1 0 011-.69h9.15a1 1 0 01.93.63L18.67 12h-2A2 2 0 0015 11zm3.71 4.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 8a1 1 0 100 2 1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
